import { Routes } from '@angular/router';
import { routes as funnelRoutes } from '../../../funnel/src/app/app.routes';

export const routes: Routes = funnelRoutes;
